import { ComponentType, JSX, lazy } from "react";
import { datadogLogs as logger } from "@datadog/browser-logs";

export const componentLoaderWithRetry = (
  factory: () => Promise<{
    default: (props?: any) => JSX.Element;
  }>,
  attempts: number = 3
) => lazy(() => componentLoaderWithRetryInternal(factory, attempts));

const componentLoaderWithRetryInternal = (
  lazyComponent: () => Promise<{
    default: (props?: any) => JSX.Element;
  }>,
  attempts: number,
  attemptNumber: number = 1
) => {
  return new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error: any) => {
        const intervalMs = (Math.pow(attemptNumber, 2) / 2) * 1000; // exponential back off
        const message = `componentLoaderWithRetryInternal: chunk loading error, retrying in ${intervalMs} milliseconds (attemptNumber = ${attemptNumber}, attempts = ${attempts}).`;
        logger.logger.info(message);
        console.info(message);
        setTimeout(() => {
          if (attemptNumber >= attempts) {
            const message = `componentLoaderWithRetryInternal: chunk loading error, no more attempts, rejecting (attemptNumber = ${attemptNumber}, attempts = ${attempts}).`;
            logger.logger.info(message);
            console.info(message);
            reject(error);
            return;
          }
          componentLoaderWithRetryInternal(
            lazyComponent,
            attempts,
            attemptNumber + 1
          ).then(resolve, reject);
        }, intervalMs);
      });
  });
};
